import { gql } from '@apollo/client';
/**
 * @const EntityHistory
 * @since 1.0.0
 */
export const EntityHistoryQuery = gql `
  query EntityHistoryQuery($input: EntityHistoryInput!) {
    history(input: $input) {
      id
      event
      createdAt
      user {
        fullname
      }
      changes {
        after
      }
    }
  }
`;
